import Service from '@ember/service';
import PlotData from '../data/plotdata';
import Consts from '../utils/constants';
import { computed } from '@ember/object';
import merge from 'lodash.merge';

export default class PlotDataService extends Service {
    noiseDistortionGraphObjects = PlotData.noiseDistortionGraphObjects;
    inputSettlingConfig = PlotData.inputSettlingConfig;
    noiseDefaults = PlotData.defaults.noise;

    noiseFunctions = {
        getStartingPoint: {
            thd: (minY) => Math.floor((minY - 5) / 5) * 5 - 10,
            sinad: (minY) => Math.floor(minY / 5) * 5 - 10,
            enob: (minY) => Math.floor(minY) - 1,
        },
    };

    getData(gridType, gridSubType) {
        let inputSettlingConfig = PlotData.inputSettlingConfig,
            data = merge({}, inputSettlingConfig['default'], inputSettlingConfig[gridType]),
            subtab = data[Consts.INPUT_SETTLING_TAB[gridSubType]];

        if (subtab) {
            merge(data, subtab);
            delete data[Consts.INPUT_SETTLING_TAB[gridSubType]];
        }

        return data;
    }

    @computed('PlotData.noiseDistortionConfig') get defaultNoiseObject() {
        let configObject = {};
        Object.keys(PlotData.noiseDistortionConfig).forEach((key) => {
            configObject[key] = [];
        });

        return configObject;
    }

    getNoiseAndDistortionConfig(type) {
        let config = PlotData.noiseDistortionConfig[type];

        config.getStartingPoint = this.noiseFunctions.getStartingPoint[type];

        return config;
    }
}
